import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

const ViewKeysLink = ({ keys }) => {
  const [viewKey, toggleViewKey] = useState(false)
  const safeKeys = Array.isArray(keys) ? keys : []
  const icons = viewKey ? 'far fa-eye-slash fa-fw mr-2' : 'far fa-eye fa-fw mr-2'

  const keyList = (
    <Fragment>
      {safeKeys.length === 0 && <div>No keys configured.</div>}
      {safeKeys.map((k, i) => (
        <div key={k.id || i} className="mb-2">
          <div>
            <strong>
              Key {i + 1}
              {k.enabled ? (
                <span className="label label-success ml-2">Enabled</span>
              ) : (
                <span className="label label-default ml-2">Disabled</span>
              )}
            </strong>
          </div>
          <div>
            Key: <code>{k.key}</code>
          </div>
          <div>
            Secret: <code>{k.secret}</code>
          </div>
        </div>
      ))}
    </Fragment>
  )

  return (
    <Fragment>
      <div
        className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
        onClick={() => toggleViewKey(!viewKey)}
      >
        <div className={icons} /> {viewKey ? 'Hide' : 'View'} Keys
      </div>
      {viewKey && keyList}
    </Fragment>
  )
}

ViewKeysLink.propTypes = {
  keys: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      key: PropTypes.string,
      secret: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ),
}

export default ViewKeysLink
